import { Card } from "@/components/ui/Card";
import type { JummahSettings } from "@/data/types";
import { cn } from "@/lib/cn";
import { formatHHmmTo12h } from "@/lib/time";

interface Props {
  settings: JummahSettings;
  /** When true, render a warm-tint Friday highlight. */
  isToday?: boolean;
}

interface Row {
  label: string;
  time: string;
}

export function JummahCard({ settings, isToday = false }: Props) {
  const rows: Row[] = [
    { label: "Azaan", time: formatHHmmTo12h(settings.azaanTime) },
    { label: "Khutbah", time: formatHHmmTo12h(settings.khutbahTime) },
    { label: "Jama’ah", time: formatHHmmTo12h(settings.jamaahTime) },
  ];
  const announced = rows.some((r) => r.time);

  return (
    <Card
      className={cn(
        isToday && "border-masjidGreen/30 bg-masjidGreen/[0.04]",
      )}
    >
      <div className="flex items-baseline justify-between gap-3">
        <div>
          <div className="label-eyebrow">Friday</div>
          <h3 className="mt-1 font-serif text-lg text-ink">Jummah</h3>
        </div>
        {isToday ? (
          <span className="text-[10px] uppercase tracking-widest text-masjidGreen">
            Today
          </span>
        ) : null}
      </div>

      {announced ? (
        <dl className="mt-4 space-y-2.5 text-sm">
          {rows.map((r) =>
            r.time ? (
              <div key={r.label} className="flex items-baseline justify-between gap-3">
                <dt className="text-muted">{r.label}</dt>
                <dd className="font-serif tabular-nums text-base text-ink">{r.time}</dd>
              </div>
            ) : null,
          )}
        </dl>
      ) : (
        <p className="mt-3 text-sm leading-relaxed text-muted">
          Jummah times will be announced.
        </p>
      )}
    </Card>
  );
}
